import React from "react";
import { Modal, Button } from 'react-bootstrap';
import LogoutIcon from "/public/images/popup-icons/logoutIcon.svg";

const ConfirmLogoutModal = ({ isOpen, toggle, onConfirm }) => {
  return (
    <Modal show={isOpen} onHide={toggle} centered className="text-translate-modal">
      <Modal.Header className="d-flex">
        <Modal.Title className="text-translation popup_heading m-0">
          <img src={LogoutIcon} alt="Logout Icon" className="me-2" />
          <span>Confirm Logout</span>
        </Modal.Title>

        <Button variant="link" className="modalClose-Btn p-0" onClick={toggle} style={{top: "16px"}}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="24"
            height="24"
          >
            <path
              d="M18 6L6 18M6 6l12 12"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </Button>
      </Modal.Header>

      <Modal.Body>
        <div className="p-2">Are you sure you want to logout?</div>
      </Modal.Body>

      <Modal.Footer className="d-inline pb-3">
        {/* <Button variant="secondary" id="logout-cancle" onClick={toggle} >Cancel</Button>
        <Button variant="danger" id="logout-red" onClick={onConfirm}>Yes, Logout</Button> */}
        <button className="outline-btn m-0" type="button" onClick={toggle}>Cancel</button>
        <button className="btn close-button" type="button" onClick={onConfirm}>Yes, Logout</button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmLogoutModal;
